<template>
  <div class="box">
    <template v-if="isShow">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>标签管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" class="user-search" style="text-align: left;padding-top: 20px">
        <el-form-item label="" prop="SearchKey">
          <el-input style="width:280px;margin-right:10px" placeholder="根据批次号、供应商、订单编号查询" v-model="model.SearchKey" maxlength="100"></el-input>
          <el-input style="width:200px" placeholder="根据标签EID查询" v-model="model.LabelNo" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">添加</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表 -->
      <el-table border default-expand-all :data="dataList" style="width: 100%" @selection-change="selectChange"
        highlight-current-row :default-sort="{prop: 'date', order: 'descending'}">
        <el-table-column align="center" type="selection" width="50">
        </el-table-column>
        <el-table-column prop="BatchOID" label="批次ID" sortable width="180">
        </el-table-column>
        <el-table-column prop="LabelBatch" label="批次号" sortable width="180">
        </el-table-column>
        <el-table-column prop="LableSupplier" label="批次供应商" sortable width="180">
        </el-table-column>
        <el-table-column prop="BatchOrderNo" label="标签订单号" sortable width="180">
        </el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" sortable width="180">
        </el-table-column>
        <el-table-column prop="UpdateTime" label="数据修改时间" sortable width="180">
        </el-table-column>
        <el-table-column label="操作" min-width="300" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="handleDetail(scope.row)" v-if="scope.row.OID!=1">全部标签
            </el-button>
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)" v-if="scope.row.OID!=1">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-row style="text-align: left;padding-top: 10px">
        <el-pagination background @current-change="handleCurrentChange" :current-page="model.Page"
          layout="total,prev, pager, next, jumper" :total="listCount" :page-size="model.Rows">
        </el-pagination>
      </el-row>
      <add v-if="isShowAdd" :dialogFormVisible="isShowAdd" @closeAddDialog="handleCloseAdd"></add>
      <edit v-if="isShowEdit" :dialogFormVisible="isShowEdit" @closeEditDialog="handleCloseEdit" :data="editData">
      </edit>
    </template>
    <template v-if="!isShow">
      <detail :LabelBatch="LabelBatch" @closeDetail="handleCloseDetail"></detail>
    </template>
  </div>
</template>

<script>
  import {
    GetLableBatchInfo,
    DelLableBatch
  } from '../../api/tag'
  import add from './add'
  import edit from './edit'
  import detail from './detail/list'
  export default {
    components: {
      add,
      edit,
      detail
    },
    data() {
      return {
        isShowAdd: false,
        isShowEdit: false,
        listCount: null,
        LabelBatch: null,
        dataList: [],
        editData: [],
        isShow: true,
        model: {
          Page: 1,
          Rows: 10,
          SearchKey: '',
          LabelNo: ''
        },
      }
    },
    watch: {
      'model.SearchKey': {
        handler(newVal) {
          if (newVal === '') {
            this.model.SearchKey = '';
            this.GetLableBatchInfo();
          }
        }
      },
      'model.LabelNo': {
        handler(newVal) {
          if (newVal === '') {
            this.model.LabelNo = '';
            this.GetLableBatchInfo();
          }else{
            this.model.LabelNo = this.model.LabelNo.trim();
          }
        }
      }
    },
    filters: {
      filterLogo(logo) {
        if (logo) {
          return logo.split()
        }
      },
      filterImgs(images) {
        if (typeof (images) === 'string') {
          if (images.indexOf(';') != -1) {
            return images.split(';');
          } else {
            return images.split(' ');
          }
        } else {
          return images;
        }
      },
    },
    mounted() {
      this.GetLableBatchInfo();
    },
    methods: {
      GetLableBatchInfo() {
        GetLableBatchInfo(this.model).then(data => {
          if (!data.iserror) {
            this.dataList = data.data.List;
            this.listCount = data.data.Count;
          }
        })
      },
      handleCurrentChange(val) {
        this.model.Page = val;
        this.GetLableBatchInfo();
      },
      selectChange(val) {
        this.selectdata = val
      },
      handleSearch() {
        // if (this.model.SearchKey === '') {
        //   this.$message({
        //     message: '搜索内容不能为空',
        //     type: 'warning'
        //   });
        //   return false;
        // } else {
          
        // }
        this.model.SearchKey = this.model.SearchKey.trim();
        this.model.Page = 1;
        this.GetLableBatchInfo();
      },
      handleAdd() {
        this.isShowAdd = true;
      },
      handleEdit(row) {
        this.editData = row;
        this.isShowEdit = true;
      },
      handleCloseAdd() {
        this.isShowAdd = false;
        this.GetLableBatchInfo();
      },
      handleCloseEdit() {
        this.isShowEdit = false;
        this.GetLableBatchInfo();
      },
      handleDelete(row) {
        let id = row.BatchOID;
        this.$confirm('确认要删除该标签吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.DelLableBatch(id);
        })
      },
      DelLableBatch(id) {
        DelLableBatch({
          BatchOID: id
        }).then(data => {
          if (!data.iserror) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.GetLableBatchInfo();
          }
        })
      },
      handleDetail(row) {
        this.LabelBatch = row.LabelBatch;
        this.isShow = false;
      },
      handleCloseDetail() {
        console.log('111')
        this.isShow = true;
      }
    }

  }
</script>

<style>
  .el-icon-circle-close:before {
    color: #ffffff;
  }
</style>